export default "__VITE_ASSET__COx4U5H$__"